import {NgModule} from '@angular/core';
import {BooleanTypePipe} from '../pipes/booleantype.pipe';
import {ExcerptPipe} from '../pipes/excerpt.pipe';
import { RelativeTimePipe } from '../pipes/relative-time.pipe';
import {ReplaceOnEmptyPipe} from '../pipes/replace-on-empty.pipe';
import { localTimePipe } from '../pipes/local-time.pipe';
import { localDatePipe } from '../pipes/local-date.pipe';
import { localDateTimePipe } from '../pipes/local-datetime.pipe';
import { localDateLongPipe } from '../pipes/local-date-long.pipe';
import { localCurrencyPipe } from '../pipes/local-currency.pipe';
import { CurrencyPipe } from '@angular/common';

@NgModule({
  declarations: [ExcerptPipe, ReplaceOnEmptyPipe, BooleanTypePipe, RelativeTimePipe, localTimePipe, localDatePipe, localDateTimePipe, localDateLongPipe, localCurrencyPipe],
  imports: [],
  exports: [ExcerptPipe, ReplaceOnEmptyPipe, BooleanTypePipe, RelativeTimePipe, localTimePipe, localDatePipe, localDateTimePipe, localDateLongPipe, localCurrencyPipe],
  providers: [
    CurrencyPipe,
    localTimePipe,
    localDatePipe,
    localDateTimePipe,
    localDateLongPipe,
    localCurrencyPipe
  ],
})
export class PipesModule {
}
